import { motion } from "framer-motion";

export default function ScrollReveal({ children, delay = 0, className = "", direction = "up" }) {
  const y = direction === "up" ? 28 : direction === "down" ? -28 : 0;
  const x = direction === "left" ? 28 : direction === "right" ? -28 : 0;

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, x }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}
